export const PUBLIC_ID_LENGTH = 8
const PUBLIC_ID_PATTERN = /^[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{3}-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}$/

export function looksLikePublicId(value: string): boolean {
  const normalized = value.trim().toUpperCase()
  return normalized.length === PUBLIC_ID_LENGTH && PUBLIC_ID_PATTERN.test(normalized)
}
